import _ from 'lodash'
import classNames from 'classnames'
import Avatar from '@mui/material/Avatar'
import { useDispatch, useSelector } from 'react-redux'
import { translate } from 'react-multi-lang'
import React, { useCallback, useRef } from 'react'

import { getUserId } from '../../helpers/storage/user'
import { formatGeneralDate } from '../../helpers/date/date'
import { formatChatroomLastMessageTime } from '../../helpers/date/messages'
import QuillViewer from '../../components/helper/QuillViewer'
import { getChatroomMember } from '../../helpers/socket/chatroom'
import { SpinnerLoader } from '../../components/Loader/ChatLoader'

import './style.css'
import '../Stream/Live/pages/Performer/styles/LiveStreamingPerformer.css'
import { fetchUserChatroomsStart } from '../../store/actions/ChatAction'
const defaultProfile = 'https://d9apl513jlx0u.cloudfront.net/public_assets/src/images/default/profile_placeholder.jpg'

const ChatroomListItem = ({ member, chatroom }) => {
  const isRead = () => {
    const message = getLastMessage(chatroom)
    return !message ? true : message.user_id === getUserId() ? true : message.is_read
  }

  const getLastMessage = (chatroom) => {
    const { messages } = chatroom
    if (_.isEmpty(messages)) {
      return null
    }
    return messages[0]
  }

  const getLastMessageTime = (updatedAt) => {
    return formatChatroomLastMessageTime(updatedAt, formatGeneralDate)
  }

  return (
    <>
      <div className='imgchat'>
        <Avatar
          src={member?.picture}
          style={{ width: '72px', height: '72px' }}
          className=' img-fluid'
          alt='avtar'
        >
          <img src={defaultProfile} style={{ width: '72px', height: '72px' }} alt='profile' />
        </Avatar>
      </div>
      <div
        className={classNames('username-text', {
          read: isRead(),
          unread: !isRead(),
        })}
      >
        <p>{`${member?.name}`}</p>
        <p>
          {getLastMessage(chatroom) ? (
            <>
              <QuillViewer
                className='message-items'
                id={`sidebar-message-item-editor-${chatroom?.id}`}
                placeholder=''
                value={getLastMessage(chatroom).text}
                readOnly={true}
              />
            </>
          ) : (
            <>No messages</>
          )}
        </p>
      </div>
      <div className='checkbox-btn chattime'>
        {getLastMessage(chatroom) ? (
          <span className='timeoutchat'>
            {getLastMessageTime(getLastMessage(chatroom).updated_at)}
          </span>
        ) : (
          <></>
        )}
      </div>
    </>
  )
}


const ChatroomList = ({ selectChatroom }) => {
  const observer = useRef()
  const dispatch = useDispatch()

  const chatrooms = useSelector((state) => state.chat.chatrooms)
  const chatFilters = useSelector((state) => state.chat.chatFilters)
  const chatroom = useSelector((state) => state.chat.activeConversation.chatroom)

  const getChatrooms = () => chatrooms?.data?.result || []
  const getPage = () => chatrooms?.data?.metadata?.pagination.page || 0
  const getLimit = () => chatrooms?.data?.metadata?.pagination.limit || 10
  const getNumberOfPages = () => chatrooms?.data?.metadata?.pagination.numberOfPages || 0

  const lastElementRef = useCallback(
    (node) => {
      if (chatrooms.loading) return;
      if (observer.current) {
        observer.current.disconnect()
      }

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && getPage() < getNumberOfPages()) {
          dispatch(fetchUserChatroomsStart({
            limit: getLimit(),
            page: getPage() + 1,
            user_id: getUserId(),
            chatroomsFilter: chatFilters.chatroomsFilter
          }));
        }
      })
      if (node) {
        observer.current.observe(node)
      }
    },
    [chatrooms?.data?.metadata?.pagination?.page, chatrooms.loading]
  )

  return (
    <>
      {getChatrooms().length > 0 &&
        getChatrooms()
          .map((room, i) => {
            const data = getChatroomMember(room)
            if (chatrooms?.data?.result?.length === i + 1) {
              return (
                <li
                  key={`_chatroom_${room.id}`}
                  ref={lastElementRef}
                  onClick={() => selectChatroom(room)}
                  className={`${chatroom?.id === room.id ? 'active' : ''}`}
                >
                  <ChatroomListItem member={data} chatroom={room} />
                </li>
              )
            }
            return (
              <li
                key={`_chatroom_${room.id}`}
                onClick={() => selectChatroom(room)}
                className={`${chatroom?.id === room.id ? 'active' : ''}`}
              >
                <ChatroomListItem member={data} chatroom={room} />
              </li>
            )
          }
        )}
      {chatrooms.loading && <SpinnerLoader />}
      {!chatrooms.loading && getChatrooms().length === 0 && <h6 className='text-center'>No chatrooms</h6>}
    </>
  )
}

export default translate(ChatroomList)
